<template>
  <div class="main">
    <!-- 支払い方法選択画面 -->
    <header-title title="支払い方法選択" />
    <div class="card-container">
      <!-- クレジットカード -->
      <div class="card" @click.prevent="toCredit">
        <img :src="credit" alt="クレジットカード" class="card--img__credit" />
        <span>
          クレジットカードで決済する
        </span>
      </div>
      <!-- 各種コード -->
      <div class="card" @click.prevent="toCoupon">
        <img :src="ticket" alt="クーポンチケット" class="card--img__coupon" />
        <span>
          クーポンコードを利用する
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../design/HeaderTitleSlot";

// 画像データ
import credit from "../../static/credit.png";
import ticket from "../../static/ticket.png";

export default {
  data() {
    return {
      credit,
      ticket,
    };
  },
  components: {
    HeaderTitle,
  },
  methods: {
    toCredit() {
      this.$router.push({
        name: "card",
      });
    },
    toCoupon() {
      this.$router.push({
        name: "coupon",
      });
    },
  },
};
</script>

<style scoped>
/**
TODO スマホ用のレイアウト作成
*/
.main {
  border-top: 100px;
  box-sizing: border-box;
}

.card-container {
  display: flex;
}
.card {
  box-sizing: border-box;
  border: 4px solid #e6e6e6;
  border-radius: 10px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.card:hover {
  cursor: pointer;
  opacity: 0.7;
}
.card > img {
  width: 100px;
  height: auto;
}

.card > span {
  display: inline-block;
  margin-top: 20px;
}
</style>
